import classNames from '@/lib/misc/classNames';
import { TokenWithMetadata } from '@/hooks/explore/useTrendingTokens';
import SearchHome from '@/components/explore/SearchHome';
import { ChainId } from '@shared/utils/config/networks';
export default function SelectToAsset({
  setToAssets,
  selectToAsset,
  toAssets,
  fromAssets,
  setSelectFromAsset,
  setSelectToAsset
}) {
  return <div className='border-b w-full h-full  lg:flex lg:flex-col lg:justify-between relative' data-sentry-component="SelectToAsset" data-sentry-source-file="SelectToAsset.tsx">
      <div className={classNames('  overflow-y-scroll w-full', selectToAsset && toAssets?.length == 0 ? 'h-[100%]' : 'h-[100%]')}>
        <SearchHome isPopup={true} setSelectToAsset={setSelectToAsset} className='' rowIsSelectedFunction={(token: any | TokenWithMetadata) => {
        const tokenItem = token?.token || token;
        if (selectToAsset) {
          return toAssets?.some(assetItem => assetItem.contract_address === tokenItem.address && (assetItem.network === token?.network || token?.networkId || token?.info?.networkId));
        } else {
          return toAssets?.some(assetItem => assetItem.contract_address === tokenItem.address && (assetItem.network === token?.network || token?.networkId || token?.info?.networkId));
        }
      }} backFunction={() => {
        setSelectFromAsset(false);
        setSelectToAsset(false);
      }} onTokenClick={(token: any | TokenWithMetadata) => {
        console.log('selected token: ', token);
        if (token?.token) {
          token = token.token;
        }
        const tokenAddress = token?.address;
        const decimals = token?.decimals;
        const name = token?.name || token?.info?.name;
        const logo = token?.token?.toAsset.logo_url || token?.info?.imageSmallUrl || token?.logo || token?.imageSmallUrl || token?.info?.imageThumbUrl;
        const network = token?.network || token?.networkId || token?.info?.networkId;
        const symbol = token?.symbol || token?.info?.symbol;
        const targetObj = {
          contract_address: tokenAddress,
          contract_decimals: decimals,
          contract_name: name,
          contract_ticker_symbol: symbol,
          logo_url: logo,
          logo,
          network: network
        };
        const newAssetsWithPercentage = [{
          ...targetObj,
          percentage: 100
        }];
        if (selectToAsset) {
          setToAssets(newAssetsWithPercentage);
        } else {
          setToAssets(newAssetsWithPercentage);
        }
        setSelectToAsset(false);
      }} data-sentry-element="SearchHome" data-sentry-source-file="SelectToAsset.tsx" />
      </div>
    </div>;
}